import React from 'react';
import PropTypes from 'prop-types';
import {CategoryStyled, CategoryNameStyled} from './Category.style';
import {Wrapper, Description, CategoryHeader} from './InfoSection.style';

const InfoSection = props => {
  const {menuName, menuDescription} = props;
  const description = menuDescription && <Description>{menuDescription}</Description>;

  return (
    <Wrapper>
      <CategoryStyled>
        <CategoryHeader>
          <CategoryNameStyled>{menuName}</CategoryNameStyled>
        </CategoryHeader>
        {description}
      </CategoryStyled>
    </Wrapper>
    );
};

InfoSection.propTypes = {
  menuName: PropTypes.string.isRequired,
  menuDescription: PropTypes.string
};

export default InfoSection;



// WEBPACK FOOTER //
// ./components/Categories/InfoSection.js